"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponsiveLayoutProvider = void 0;
exports.useResponsiveLayout = useResponsiveLayout;
var _jsxRuntime = require("@emotion/react/jsx-runtime");
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const responsiveLayoutContext = /*#__PURE__*/React.createContext({
  setActiveSectionTitle: () => {
    // function
  },
  setHiddenComponent: () => {
    // function
  },
  setIsHeaderHidden: () => {
    //function
  },
  activeSectionTitle: undefined,
  hiddenComponent: null,
  isRootContext: true,
  isHeaderHidden: false
});
function useResponsiveLayout() {
  const context = React.useContext(responsiveLayoutContext);
  if (context.isRootContext) {
    throw new Error('useResponsiveLayout must be used within a ResponsiveLayoutProvider');
  }
  return context;
}
const ResponsiveLayoutProvider = ({
  children
}) => {
  const [hiddenComponent, setHiddenComponent] = React.useState(null);
  const [isHeaderHidden, setIsHeaderHidden] = React.useState(false);
  const [activeSectionTitle, setActiveSectionTitle] = React.useState('');
  return (0, _jsxRuntime.jsx)(responsiveLayoutContext.Provider, {
    value: {
      activeSectionTitle,
      setActiveSectionTitle,
      hiddenComponent,
      setHiddenComponent,
      isHeaderHidden,
      setIsHeaderHidden,
      isRootContext: false
    },
    children: children
  });
};
exports.ResponsiveLayoutProvider = ResponsiveLayoutProvider;